import CreateChildModal from './CreateChildModal';
import ConnectedCreateChildModal from './ConnectedCreateChildModal';
import EditChildModal from './EditChildModal';
import ConnectedEditChildModal from './ConnectedEditChildModal';
import './ChildModal.less';

export {
  ConnectedCreateChildModal,
  CreateChildModal,
  ConnectedEditChildModal,
  EditChildModal
};
